<a class="skip-link" href="#conteudo" (click)="focusContent($event)">Ir para o conteúdo da aba</a>

<div id="preload" inert>
  <ngx-monaco-editor />
</div>

<input
  #fileInput
  type="file"
  hidden
  multiple
  accept=".por,.json,text/plain,application/json"
  (change)="openFiles($event)"
/>

<main id="conteudo" class="editor-area" tabindex="-1" aria-label="Abas">
  <div class="tab-strip">
    <div #tablist class="tablist" role="tablist" aria-label="Abas abertas">
      <div class="tab" role="presentation" [class.active]="activeTabId() === null">
        <button
          id="aba-inicio"
          type="button"
          class="tab-label"
          role="tab"
          aria-controls="painel-inicio"
          [attr.aria-selected]="activeTabId() === null"
          [tabIndex]="activeTabId() === null ? 0 : -1"
          (click)="selectTab(null)"
        >
          <svg-icon src="assets/lightbulb.svg" class="tab-icon icon-yellow" aria-hidden="true" />
          <span class="tab-title">Portugol Webstudio</span>
        </button>
      </div>

      @for (tab of tabs(); track tab.id) {
        <div class="tab" role="presentation" [class.active]="activeTabId() === tab.id">
          <button
            type="button"
            class="tab-label"
            role="tab"
            [attr.aria-describedby]="
              tab.type === 'editor' && !isOwnExerciseTab(tab) ? 'atalhos-aba-codigo' : 'atalhos-aba'
            "
            [id]="`aba-${tab.id}`"
            [attr.aria-controls]="`painel-${tab.id}`"
            [attr.aria-selected]="activeTabId() === tab.id"
            [tabIndex]="activeTabId() === tab.id ? 0 : -1"
            (click)="selectTab(tab.id)"
            (auxclick)="$event.button === 1 && closeTab(tab, 'abas')"
            (dblclick)="changeTabTitle(tab, 'abas')"
          >
            <svg-icon
              class="tab-icon"
              aria-hidden="true"
              [src]="tab.exerciseId ? 'assets/mdi/puzzle-outline.svg' : tabIcons[tab.type]"
              [class.icon-blue]="tab.type !== 'editor'"
              [class.icon-green]="isOwnExerciseTab(tab)"
            />
            <span class="tab-title">
              @if (tab.exerciseId) {
                <span class="visually-hidden">{{ tab.exerciseCopy ? "Cópia de exercício: " : "Exercício: " }}</span>
              }
              {{ tab.title }}
            </span>
          </button>

          @if (tab.type === "editor" && !isOwnExerciseTab(tab)) {
            <span
              class="icon-btn icon-btn-sm tab-action"
              aria-hidden="true"
              data-tab-action="rename"
              appTooltip="Renomear"
              appTooltipShortcut="F2"
              [attr.data-tab-id]="tab.id"
            >
              <svg-icon src="assets/mdi/pencil-outline.svg" />
            </span>
          }

          <span
            class="icon-btn icon-btn-sm tab-action"
            aria-hidden="true"
            data-tab-action="close"
            appTooltip="Fechar"
            appTooltipShortcut="Delete"
            [attr.data-tab-id]="tab.id"
          >
            <svg-icon src="assets/mdi/close.svg" />
          </span>
        </div>
      }
    </div>

    <button
      type="button"
      class="icon-btn new-tab"
      aria-label="Nova aba de código"
      aria-keyshortcuts="Alt+N"
      appTooltip="Nova aba de código"
      appTooltipShortcut="Alt+N"
      (click)="newTab('abas')"
    >
      <svg-icon src="assets/mdi/plus.svg" aria-hidden="true" />
    </button>

    <span id="atalhos-aba-codigo" class="visually-hidden">Delete fecha a aba; F2 renomeia.</span>
    <span id="atalhos-aba" class="visually-hidden">Delete fecha a aba.</span>
  </div>

  <div
    id="painel-inicio"
    class="tab-panel"
    role="tabpanel"
    tabindex="-1"
    aria-labelledby="aba-inicio"
    [hidden]="activeTabId() !== null"
  >
    <app-tab-start
      (newTab)="$event ? addTab($event.name, $event.contents) : newTab('inicio')"
      (openFile)="chooseFiles('inicio')"
      (examples)="openExamplesDialog('inicio')"
      (exercises)="openExercisesDialog('inicio')"
      (help)="upsertHelpTab('inicio')"
      (changelog)="upsertChangelogTab($event)"
      (settings)="openSettingsDialog()"
    />
  </div>

  @for (tab of tabs(); track tab.id) {
    <div
      class="tab-panel"
      role="tabpanel"
      tabindex="-1"
      [id]="`painel-${tab.id}`"
      [attr.aria-labelledby]="`aba-${tab.id}`"
      [hidden]="activeTabId() !== tab.id"
    >
      @switch (tab.type) {
        @case ("editor") {
          <app-tab-editor
            [tabId]="tab.id"
            (help)="upsertHelpTab($event)"
            (settings)="openSettingsDialog($event)"
            (openFile)="chooseFiles($event)"
            (examples)="openExamplesDialog('editor')"
            (exercisesDialog)="openExercisesDialog('editor')"
            (newTab)="newTab('atalho')"
            (closeTab)="closeActiveTab()"
          />
        }

        @case ("help") {
          <app-tab-help [tabId]="tab.id" (newTab)="addTab($event.name, $event.contents)" />
        }

        @case ("changelog") {
          <app-tab-changelog />
        }

        @case ("exercise-builder") {
          @defer {
            <app-tab-exercise-builder [tabId]="tab.id" />
          } @loading (minimum 200ms) {
            <div class="tab-loading" role="status">
              <span class="spinner" aria-hidden="true"></span>
              <span class="visually-hidden">Carregando a criação de exercício</span>
            </div>
          } @error {
            <p class="tab-load-error">Não foi possível carregar a criação de exercício.</p>
          }
        }

        @default never;
      }
    </div>
  }
</main>

<footer class="status-bar" aria-label="Barra de status">
  @if (activeEditor(); as editor) {
    <button
      type="button"
      class="status-item"
      appTooltip="Ver os problemas do código"
      appTooltipPosition="above"
      [attr.aria-label]="problemsLabel()"
      (click)="editor.showProblems()"
    >
      <svg-icon src="assets/mdi/close-circle-outline.svg" aria-hidden="true" />
      {{ problemCounts().errors }}
      <svg-icon src="assets/mdi/alert-outline.svg" aria-hidden="true" />
      {{ problemCounts().warnings }}
      @if (problemCounts().infos > 0) {
        <svg-icon src="assets/mdi/information-outline.svg" aria-hidden="true" />
        {{ problemCounts().infos }}
      }
    </button>

    @if (editor.paused()) {
      <span class="status-item status-running status-paused">
        <svg-icon src="assets/mdi/pause.svg" aria-hidden="true" />
        Pausado na linha {{ editor.debugPause()?.line }}
      </span>
    } @else if (editor.executor.waitingForInput) {
      <span class="status-item status-running status-waiting">
        <svg-icon src="assets/mdi/keyboard-outline.svg" aria-hidden="true" />
        Aguardando entrada
      </span>
    } @else if (editor.executor.running && !editor.stepInFlight()) {
      <span class="status-item status-running">
        <svg-icon src="assets/mdi/play-outline.svg" aria-hidden="true" />
        Executando
      </span>
    }

    <span class="status-spacer"></span>

    <button
      type="button"
      class="status-item"
      appTooltip="Ir para a linha"
      appTooltipShortcut="Ctrl+G"
      appTooltipPosition="above"
      (click)="editor.goToLine()"
    >
      Ln {{ editor.cursor().line }}, Col {{ editor.cursor().column }}
    </button>

    <button
      type="button"
      class="status-item"
      appTooltip="Mudar a indentação nas configurações"
      appTooltipPosition="above"
      (click)="openStatusBarSettings()"
    >
      {{ indentationLabel() }}
    </button>

    <span class="status-item">Portugol</span>
  } @else {
    <span class="status-spacer"></span>
  }

  @if (isBeta) {
    <span class="status-item status-beta">Beta</span>
  }
</footer>
